import { Loader } from 'braid-design-system';
import { useAtomValue } from 'jotai';
import type React from 'react';

import { usePayments } from '../../../context/PaymentsProvider';
import { isStripeLoadedAtom } from '../../../context/StripeProviderStore';
import { savedCardInfoAtom } from '../../../usecases/CreditCard/CreditCardStore';
import { checkAdvNationMapping } from '../../../utils/mapCurrencyNation';
import StripeNotLoadedError from '../../StripeNotLoadedError/StripeNotLoadedError';

import StripeForm from './stripeForm';
import StripeSavedCard from './stripeSavedCard';

const CreditCard = () => {
  const {
    savedCreditCard,
    creditCardForm,
    currency,
    advertiserNation,
    isOrderSummaryLoading,
  } = usePayments();

  const savedCardInfo = useAtomValue(savedCardInfoAtom);

  const country = checkAdvNationMapping(advertiserNation, currency);

  const stripeIsLoaded = useAtomValue(isStripeLoadedAtom);

  if (!stripeIsLoaded) {
    return <StripeNotLoadedError />;
  }

  if (savedCreditCard?.isGetSavedCardsLoading || isOrderSummaryLoading) {
    return <Loader size="small" />;
  }

  if (savedCardInfo !== undefined) {
    return <StripeSavedCard savedCreditCard={savedCreditCard} />;
  }

  return <StripeForm creditCardForm={creditCardForm} country={country} />;
};

export default CreditCard;
